import { render, staticRenderFns } from "./buy-card.vue?vue&type=template&id=f30a9dda&scoped=true&"
import script from "./buy-card.vue?vue&type=script&lang=js&"
export * from "./buy-card.vue?vue&type=script&lang=js&"
import style0 from "./buy-card.vue?vue&type=style&index=0&id=f30a9dda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30a9dda",
  null
  
)

export default component.exports